import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, input } from '@angular/core';
import { ItemComponentBase, WireCutItemDescriptionComponent } from 'products-ui';
import { CartItemPriceViewComponent } from '../../../../../common/cart-item-price/views/cart-item-price-view/cart-item-price-view.component';

@Component({
  selector: 'ideal-wire-cut-cart-item-summary-view',
  imports: [CartItemPriceViewComponent, WireCutItemDescriptionComponent, JsonPipe],
  standalone: true,
  templateUrl: './wire-cut-cart-item-summary-view.component.html',
  styleUrl: './wire-cut-cart-item-summary-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // providers: [WireCutItemDetailsComponentStore]
})
export class WireCutCartItemSummaryViewComponent extends ItemComponentBase {
  // private readonly _itemStore = inject(WireCutItemDetailsComponentStore);
  public readonly quantity = input.required<number>();
  public readonly customLength = computed(() => +(this.id()?.options.value('Z') || 1));

  // protected readonly typeLabel = computed(() => {
  //   const opts = this.itemOptions();
  //   if(opts?.has('Z')){
  //     return 'Custom Cut';
  //   }
  //   return 'Roll';
  // });

  // protected readonly itemDetails = computed(() => this._itemStore.wireCutItemDetails());

  // protected readonly length = computed(() => {
  //   const opts = this.itemOptions();
  //   if(opts?.has('Z')){
  //     return opts.value('Z') || '1';
  //   }else{
  //     this._itemStore.wireCutItemDetails().
  //   }
  //   return 'Roll';
  // });
}
